import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { v4 as uuidv4 } from "uuid"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import {
  addHeldOrder,
  clearDeliveryInfo,
  clearOrderTableNumber,
  deleteAllOrderItems
} from "@redux"
import { moment } from "utils"
import classes from "./HoldButton.module.scss"

const HoldButton = () => {
  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const order = useSelector(state => state.order)

  const deliveryType =
    useSelector(state =>
      state.deliveryInfo.deliveryType
    )

  const validate = () => {
    const isCartEmpty =
      order.items.length === 0 &&
      order.combos.length === 0

    if (isCartEmpty) return false

    return true
  }

  const handleHoldOrder = () => {
    if (!validate()) return

    const heldOrder = {
      _id: uuidv4(),
      date: moment().toISOString(),
      deliveryType,
      items: order.items,
      combos: order.combos,
      tableNumber: order.tableNumber
    }

    dispatch(
      addHeldOrder(heldOrder)
    )

    dispatch(clearDeliveryInfo())

    dispatch(deleteAllOrderItems())

    dispatch(
      clearOrderTableNumber()
    )

    toast.success(t("سفارش_نگه_داشته_شد"))
  }

  const isLtr =
    i18n.dir(i18n.language) === "ltr"

  return (
    <button
      className={clsx(classes["button"], isLtr && classes["button-ltr"])}
      onClick={handleHoldOrder}
    >
      {t("نگهداری")}
    </button>
  )
}

export default HoldButton